export default class ContentNavScroll {
    constructor() {
        this.navSelector = '#content-nav';
        this.headerHeight = $('.header-global .sticky-wrapper').outerHeight();
        this.stickyNavHeight = $('#sticky-nav').outerHeight() || 0;
        this.totalOffset = this.headerHeight + this.stickyNavHeight + 20;
        this.setUpScroll();
    }

    setUpScroll() {
        $('body').scrollspy({
            target: this.navSelector,
            offset: this.totalOffset + 1,
        });

        $('.sidebar-nav').on('click', 'a.nav-link', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const $el = $(e.currentTarget);
            const href = $el.attr('href');
            $('html,body').animate({ scrollTop: $(href).offset().top - this.totalOffset });
        });

        $(window).on('activate.bs.scrollspy', () => {
            const $parent = $('.sidebar-nav .nav-link.active').closest('li');
            const index = $parent.index();
            if (index === 0) {
                // $('.sidebar-nav .nav-link.active').addClass('stay-active');
            } else {
                $('.sidebar-nav .stay-active').removeClass('stay-active');
            }
        });
    }
}
